import { Tab, TabList } from '@fluentui/react-components'
import { useTranslation } from 'react-i18next'
import type { HierarchyViewMode } from '../../utils/filter-section-tree'
import { useStyles } from './HierarchyViewPills.styles'

interface HierarchyViewPillsProps {
  value: HierarchyViewMode
  onChange: (mode: HierarchyViewMode) => void
}

const TAB_VALUES: HierarchyViewMode[] = ['all', 'sections', 'tables']

export function HierarchyViewPills({ value, onChange }: HierarchyViewPillsProps) {
  const { t } = useTranslation()
  const styles = useStyles()

  return (
    <div className={styles.root}>
      <TabList
        selectedValue={value}
        onTabSelect={(_, tabData) => {
          if (tabData.value == null) return
          onChange(tabData.value as HierarchyViewMode)
        }}
        appearance="subtle-circular"
        size="medium"
        className={styles.tabList}
        aria-label={t('files.hierarchyView.label')}>
        {TAB_VALUES.map((tabValue) => (
          <Tab key={tabValue} value={tabValue}>
            {t(`files.hierarchyView.${tabValue}`)}
          </Tab>
        ))}
      </TabList>
    </div>
  )
}
